import { useForm } from 'react-hook-form'
import {
  Box,
  Button,
  HStack,
  Spinner,
  Text
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import { PasswordInput } from 'common/Inputs/PasswordInput'
import {
  CONFIRM_PASSWORD,
  PASSWORD,
  PENDING
} from 'utils/constants'
import { COLORS } from 'utils/styles'
import { ChangePasswordValidationScheme } from 'validation'

export const ResetPassword = ({
  animateOut,
  handleBack,
  handleVerify,
  headerBgPos,
  ImagesPng,
  MotionBox,
  resetPasswordStatus
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(ChangePasswordValidationScheme)
  })

  const onSubmit = (data) => handleVerify(data)

  return (
    <MotionBox
      initial={{
        y: animateOut ? 0 : window.innerHeight
      }}
      animate={{
        y: animateOut ? window.innerHeight : 0
      }}
      transition={{
        type: animateOut ? 'tween' : 'spring',
        duration: 1
      }}
      width="90%"
      minWidth="40svw"
      maxWidth="650px"
      height="auto"
      padding="35px 30px"
      textAlign="center"
      overflow="hidden"
      backgroundColor="rgb(255, 255, 255)"
      borderRadius="10px"
      alignItems="center"
      zIndex="10"
    >
      <Box
        backgroundColor={COLORS.gold}
        backgroundImage={`url(${ImagesPng.YellowMapTexture})`}
        backgroundPosition={`${headerBgPos.current.x}px ${headerBgPos.current.y}px`}
        padding="20px 30px"
        border={`solid ${COLORS.darkGray} 1.5px`}
        borderRadius="10px"
        boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
        marginBottom="30px"
      >
        <Text fontSize="25px" fontWeight="bold">
          Reset Password
        </Text>
        <Text fontSize="16px">
          {`
            Make your password at least 8 characters — 
            adding numbers & symbols is recommended, but not required
          `}
        </Text>
      </Box>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box spacing="16px">
          <PasswordInput
            error={errors.password}
            register={register(PASSWORD)}
            placeholder="New Password"
            marginTop="-10px"
            marginBottom="10px"
          />
          <PasswordInput
            error={errors.confirmPassword}
            register={register(CONFIRM_PASSWORD)}
            placeholder="Confirm New Password"
            marginTop="-10px"
            marginBottom="10px"
          />
        </Box>

        <HStack justify="center" justifyContent="space-evenly" marginTop="50px">
          <Button
            type="button"
            width="20%"
            minWidth="100px"
            backgroundColor={
              resetPasswordStatus === PENDING
                ? COLORS.gray
                : COLORS.gold
            }
            pointerEvents={resetPasswordStatus === PENDING ? 'none' : 'auto'}
            cursor={resetPasswordStatus === PENDING ? 'default' : 'cursor'}
            _hover={{
              backgroundColor: resetPasswordStatus === PENDING
                ? COLORS.gray
                : COLORS.gold_hover
            }}
            onClick={() => handleBack()}
          >
            { resetPasswordStatus === PENDING ? <Spinner size="md" /> : 'Cancel' }
          </Button>

          <Button
            type="submit"
            width="20%"
            minWidth="100px"
            backgroundColor={
              resetPasswordStatus === PENDING
                ? COLORS.gray
                : COLORS.gold
            }
            pointerEvents={resetPasswordStatus === PENDING ? 'none' : 'auto'}
            cursor={resetPasswordStatus === PENDING ? 'default' : 'cursor'}
            _hover={{
              backgroundColor: resetPasswordStatus === PENDING
                ? COLORS.gray
                : COLORS.gold_hover
            }}
          >
            { resetPasswordStatus === PENDING ? <Spinner size="md" /> : 'Confirm' }
          </Button>
        </HStack>
      </form>
    </MotionBox>
  )
}
